import React, { useState, useEffect, useRef } from 'react';
import axios from "axios";
import Header from '../Header';
import Footer from '../Footer';
import FlashMessage from '../FlashMessage';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import Select from 'react-select';
import 'datatables.net-bs5';
import { Link, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import Swal from 'sweetalert2';
import "../../components/css/custom-filter.css";
import { setTableWidths, getTableWidths } from "../../data/postAPi";

// Add custom styles for fixed header table
const tableStyles = `
	.table-container {
		height: calc(100vh - 190px);
		overflow: auto;
		position: relative;
		border-radius: 0.375rem;
	}
	
	.table-container table {
		width: 100%;
		border-collapse: collapse;
		margin-bottom: 0;
	}
	
	.table-container thead {
		position: sticky;
		top: 0;
		z-index: 2;
	}
	
	
	.table-container::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}
	
	.table-container::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 4px;
	}
	
	.table-container::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 4px;
	}
	
	.table-container::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}
`;

const CreateNewManifest = () => {
	const [driverOptions, setDriverOptions] = useState([]);
	const [driverValue, setDriverValue] = useState('');
	const [mIdValue, setMIdValue] = useState('');
	const [manifestList, setManifestList] = useState([]);
	const [checkedValues, setCheckedValues] = useState([]);
	const [routeOptions, setRouteOptions] = useState([]);
	const [salesRoute, setSalesRoute] = useState([]);
	const [selectedRouteValues, setSelectedRouteValues] = useState([]);
	const [selectedDriverValue, setSelectedDriverValue] = useState(null);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const selectRef = useRef(null);
	const dropdownRef = useRef(null);
	const tableRef = useRef(null);
	const [flashMessage, setFlashMessage] = useState(null);
	const [showRouteModal, setShowRouteModal] = useState(false);
	const [showRouteIframe, setShowRouteIframe] = useState(true);
	const [iframeKey, setIframeKey] = useState(0);
	const [isIframeLoading, setIsIframeLoading] = useState(false);
	const [manifestIdForMap, setManifestIdForMap] = useState([]);
	const accessToken = localStorage.getItem('accessToken');
	const user_id = localStorage.getItem('userId');
	const [companySettings, setCompanySettings] = useState(null);
	const userId = localStorage.getItem("userId");
	const tableName = "resizableCreateNewManifestTable";
	const [colWidths, setColWidths] = useState([80, 120, 150, 200, 120, 120, 120, 120, 120, 120, 100]);

	function debounce(func, wait) {
		let timeout;
		return function (...args) {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}
	const debouncedSetTableWidths = useRef(
		debounce((userId, tableName, widths) => {
			setTableWidths(userId, tableName, widths);
		}, 500)
	).current;

	const startResizing = (index, e) => {
		e.preventDefault();
		const startX = e.clientX;
		const startWidth = colWidths[index];
		const onMouseMove = (moveEvent) => {
			const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
			setColWidths((widths) => {
				const updated = [...widths];
				updated[index] = newWidth;
				debouncedSetTableWidths(userId, tableName, updated);
				return updated;
			});
		};
		const onMouseUp = () => {
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
	};

	useEffect(() => {
		async function fetchWidths() {
			try {
				const res = await getTableWidths(userId, tableName);
				if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
					setColWidths(res.data.widths);
				} else {
					setColWidths([80, 120, 150, 200, 120, 120, 120, 120, 120, 120, 100]);
				}
			} catch (e) {
				setColWidths([80, 120, 150, 200, 120, 120, 120, 120, 120, 120, 100]);
			}
		}
		fetchWidths();
	}, []);

	const handleCloseMessage = () => {
		setFlashMessage(null);
	};

	const handleChangeRoute = (selectedOptions) => {
		const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
		setSalesRoute(values);
		setSelectedRouteValues(selectedOptions);
	};

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				console.log('Clicking outside, closing dropdown');
				setIsDropdownOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handelDriverChange = (selectedOption) => {
		setSelectedDriverValue(selectedOption);
		setDriverValue(selectedOption ? selectedOption.value : '');
	};
	const navigate = useNavigate();
	const createManifestEvent = async () => {
		if (checkedValues.length > 0) {
			const formData = new FormData();
			if (salesRoute.length > 0) {
				salesRoute.forEach(value => {
					formData.append('route_no[]', value);
				});
			}
			formData.append('mId', mIdValue);
			formData.append('user_id', user_id);
			checkedValues.forEach((value, index) => {
				formData.append('val[]', value);
			});

			if (driverValue != '') {
				formData.append('driver_id', driverValue);

				const apiAddOrdersUrl = `${config.API_URL}/ws-create-manifest-v2`;
				try {
					const response = await fetch(apiAddOrdersUrl, {
						method: 'POST',
						headers: {
							authorization: `Bearer ${accessToken}`,
						},
						body: formData,
					});

					if (!response.ok) {
						setFlashMessage({ message: 'something went wrong, try again', type: 'error' });
					}
					const data = await response.json();
					console.log(data);
					if (data.success) {
						setFlashMessage({ message: 'Manifest created successfully!', type: 'success' });
						setCheckedValues([]);
						setSalesRoute([]);
						setSelectedRouteValues([]);
						setDriverValue('');
						setSelectedDriverValue(null);
						
						// Show confirmation popup for printing
						Swal.fire({
							title: 'Manifest Created Successfully!',
							text: 'Do you want to print the created manifest?',
							icon: 'success',
							showCancelButton: true,
							confirmButtonText: 'Yes, Print',
							cancelButtonText: 'No, Continue',
							reverseButtons: true
						}).then((result) => {
							if (result.isConfirmed) {
								// const printWindow = window.open(`/manifest_list/mark_delivery/${data.manifest_code}`, '_blank');
								// if (printWindow) {
								// 	printWindow.onload = function() {
								// 		setTimeout(() => {
								// 			printWindow.print();
								// 		}, 1000);
								// 	};
								// }
								navigate(`/manifest_list/mark_delivery/${data.manifest_code}?print=true`);
							}else{
								navigate(`/manifest_list/mark_delivery/${data.manifest_code}`);
							}
						});
					}
				} catch (error) {
					console.error('Error Accept Order:', error);
					setFlashMessage({ message: 'Error Accept Order order. Please check the console for details', type: 'error' });
				}
			} else {
				setFlashMessage({ message: 'please select driver', type: 'error' });
			}
		} else {
			Swal.fire({
				title: 'Error',
				text: 'please select order to create manifest.',
				icon: 'error',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true,
			});
		}
	};

	const fetchDriversOptions = async () => {
		const apiSalesRapUrl = `${config.API_URL}/getDriver`;
		try {
			const response = await fetch(apiSalesRapUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				}
			});

			const data = await response.json();
			console.log(data);
			const formattedOptions = data.data.driver.map(item => ({
				label: `${item.first_name} ${item.last_name}`,
				value: item.id,
			}));
			setDriverOptions(formattedOptions);
		} catch (error) {
			console.error('api fail Error fetching Not Order Report:', error);
		}
	};

	const fetchSalesRoute = async () => {
		const apiSalesRouteUrl = `${config.API_URL}/getRoute`;
		try {
			const response = await fetch(apiSalesRouteUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				}
			});

			const data = await response.json();
			console.log('Route API Response:', data);
			const formattedOptions = data.data.map(item => ({
				label: item.route_number,
				value: item.id,
			}));
			console.log('Formatted Route Options:', formattedOptions);
			setRouteOptions(formattedOptions);
		} catch (error) {
			console.error('api fail error fetching sales routes:', error);
		}
	};

	const fetchRoutePlanningList = async () => {
		console.log('🔄 Calling ws-route-planning-list API...');
		setCheckedValues([]);
		setManifestList([]); // Clear the manifest list first

		const routeData = new FormData();
		routeData.append('draw', 1);
		routeData.append('start', 0);
		routeData.append('length', 50);
		routeData.append('user_id', user_id);

		console.log('salesRoute', salesRoute);

		// Always send route[] parameter, even if empty
		if (salesRoute.length > 0) {
			salesRoute.forEach(value => {
				routeData.append('route[]', value);
			});
		} else {
			// Send empty route[] parameter when no routes selected
			//routeData.append('route[]', '');
		}

		// Debug: Log what's being sent
		console.log('FormData being sent:');
		for (let [key, value] of routeData.entries()) {
			console.log(`${key}: ${value}`);
		}

		const apiRoutePlanningUrl = `${config.API_URL}/ws-route-planning-list`;
		try {
			const response = await fetch(apiRoutePlanningUrl, {
				method: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				body: routeData,
			});
			const data = await response.json();
			console.log('Route Planning API Response:', data);

			if (data.success) {
				setManifestList(data.data || []);
				setMIdValue(data.mid);
				// Update DataTable with new data instead of reloading
				if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
					const dataTable = $(tableRef.current).DataTable();
					dataTable.clear();
					if (data.data && Array.isArray(data.data)) {
						dataTable.rows.add(data.data).draw();
					} else {
						dataTable.draw();
					}
				}
			} else {
				console.error('API returned success: false');
				setManifestList([]);
				// Clear the table when API fails
				if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
					$(tableRef.current).DataTable().clear().draw();
				}
			}
		} catch (error) {
			console.error('api fail Error fetching Route Planning:', error);
			setManifestList([]);
			// Clear the table on error
			if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
				$(tableRef.current).DataTable().clear().draw();
			}
		}
	};

	const searchManifestEvent = () => {
		fetchRoutePlanningList();
	};

	function formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		if (isNaN(date)) return dateString;
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = String(date.getFullYear()).slice(-4);
		return `${day}-${month}-${year}`;
	}

	const getManifestList = () => {
		const $table = $(tableRef.current);
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}

		$table.DataTable({
			processing: false,
			serverSide: false,
			data: manifestList, // Use the state data instead of server-side processing
			ordering: false,
			language: {
				paginate: {
					first: "First",
					last: "Last",
					next: "Next",
					previous: "Previous",
				},
				lengthMenu: '_MENU_',
				length:false,
				search: "Search:",
				emptyTable: "No data available for the selected routes",
				zeroRecords: "No matching records found",
				info: "Showing _START_ to _END_ of _TOTAL_ entries",
				infoEmpty: "Showing 0 to 0 of 0 entries",
				infoFiltered: "(filtered from _MAX_ total entries)",
				processing: "Loading data...",
			},
			columns: [
				{
					data: null,
					render: function (data, type, row) {
						// Only render checkbox if grand_total is positive
						if (row.grand_total > 0) {
							return `
              <label class="checkbox">
                <input 
                  type="checkbox" 
                  name="val[]" 
                  value="${row.id}" 
                  class="dataTableCheckbox"
                />
                <span class="default"></span>
              </label>
            `;
						} else {
							return '';
						}
					}
				},
				{
					data: 'invoice_date',
					render: function (data, type, row) {
						return formatDate(data);
					}
				},
				{
					data: 'reference_no',
					render: function (data, type, row) {
						return `<a href="../trip_summary/print/${row.id}">${row.reference_no}</a>`;
					}
				},
				{
					data: 'customer',
					render: function (data, type, row) {
						return data ? row.customer + '(' + row.accound_no + ')' : '';
					}
				},
				{ data: 'postal_code' },
				{ data: 'grand_total' },
				{ data: 'total' },
				{ data: 'paid' },
				{ data: 'route_number' },
				{ data: 'created_by_name' },
			],
			order: [],
			pageLength: 50,
		});

		$(document).off('change', '#resizableCreateNewManifestTable .dataTableCheckbox').on('change', '#resizableCreateNewManifestTable .dataTableCheckbox', function () {
			const value = $(this).val();
			const checked = $(this).is(':checked');
			setCheckedValues(prevState => {
				let updated;
				if (checked) {
					updated = [...prevState, value];
				} else {
					updated = prevState.filter(val => val !== value);
				}
				if (!checked) {
					$('#selectAllManifest').prop('checked', false);
				} else {
					const allChecked = $('#resizableCreateNewManifestTable .dataTableCheckbox').length === $('#resizableCreateNewManifestTable .dataTableCheckbox:checked').length;
					$('#selectAllManifest').prop('checked', allChecked);
				}
				return updated;
			});
		});

		$(document).off('change', '#selectAllManifest').on('change', '#selectAllManifest', function () {
			const checked = $(this).is(':checked');
			$('#resizableCreateNewManifestTable .dataTableCheckbox').each(function () {
				if ($(this).is(':checked') !== checked) {
					$(this).prop('checked', checked).trigger('change');
				}
			});
		});
	};

	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		// Initialize DataTable and fetch initial data
		getManifestList();
		fetchRoutePlanningList();
		fetchDriversOptions();
		fetchSalesRoute();

		return () => {
			if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
				$(tableRef.current).DataTable().destroy();
			}
			$(document).off('change', '#resizableCreateNewManifestTable .dataTableCheckbox');
			$(document).off('change', '#selectAllManifest');
		};
	}, []);

	useEffect(() => {
		if (showRouteModal) {
			// Reset iframe state when modal opens
			setShowRouteIframe(false);
			setIsIframeLoading(true);
			setIframeKey(prev => prev + 1);
			
			// Add a small delay to ensure modal is fully rendered
			const timer = setTimeout(() => {
				setShowRouteIframe(true);
			}, 100);
			
			window.closeRouteModal = () => {
				setShowRouteIframe(false);
				setIsIframeLoading(false);
				setTimeout(() => {
					setShowRouteModal(false);
				}, 100);
			};

			// Add ESC key handler
			const handleEsc = (e) => {
				if (e.key === 'Escape') {
					setShowRouteIframe(false);
					setIsIframeLoading(false);
					setShowRouteModal(false);
				}
			};
			document.addEventListener('keydown', handleEsc);
			return () => {
				clearTimeout(timer);
				delete window.closeRouteModal;
				document.removeEventListener('keydown', handleEsc);
			};
		} else {
			// Reset iframe state when modal closes
			setShowRouteIframe(false);
			setIsIframeLoading(false);
			return () => {
				delete window.closeRouteModal;
			};
		}
	}, [showRouteModal]);

	// Refresh DataTable when salesRoute changes
	useEffect(() => {
		console.log('SalesRoute changed:', salesRoute);
		fetchRoutePlanningList();
	}, [salesRoute]);

	// Refresh DataTable when manifestList changes
	useEffect(() => {
		if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
			const dataTable = $(tableRef.current).DataTable();
			dataTable.clear();
			if (manifestList && Array.isArray(manifestList)) {
				dataTable.rows.add(manifestList).draw();
			} else {
				dataTable.draw();
			}
		}
	}, [manifestList]);

	const fetchCompanySettings = async () => {
		try {
			const response = await fetch(`${config.API_URL}/settings/ws-get-company-settings`, {
				method: 'POST',
				headers: {
					'Authorization': `Bearer ${accessToken}`,
				}
			});
			const data = await response.json();
			setCompanySettings(data?.data);
		} catch (error) {
			console.error('Error fetching company settings:', error);
		}
	};

	useEffect(() => {
		fetchCompanySettings();
	}, []);

	// if (!companySettings) return <div>Loading...</div>;

	return (
		<>
			<style>{tableStyles}</style>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to={`/dashboard/${accessToken}/${user_id}`}>
								<i className="fa fa-home"></i>
							</Link>
							<Link to="/delivery/route_planing">Dispatch & Delivery</Link>
							<Link to="/delivery/route_planing">Create Manifest</Link>
						</div>
					</div>
				</div>
			</div>

			<div className="main-container position-relative">
				<div className="container-fluid">
					<div className="row align-items-end create-manifest-filter-row">
						{/* <div className="col-md-3">
							<Select
								isMulti
								value={selectedRouteValues}
								onChange={handleChangeRoute}
								options={routeOptions}
								menuPortalTarget={document.body}
								styles={{
									// Fixes the overlapping problem of the component
									menu: provided => ({ ...provided, zIndex: 9999 }),
									menuPortal: provided => ({ ...provided, zIndex: 9999 })
								  }}
								placeholder="Select Routes"
								className="react-select-container"
								classNamePrefix="react-select"
							/>
						</div>

						<div className="col-md-1 d-flex align-items-end">
							<button
								type="button"
								onClick={searchManifestEvent}
								className="acceptbtn"
							>
								Submit
							</button>
						</div> */}
						{companySettings && companySettings.isShowRutePlan === 'N' && (
							<div className="col-md-6">
								<Select
									value={selectedDriverValue}
									onChange={handelDriverChange}
									options={driverOptions}
									menuPortalTarget={document.body}

									styles={{
										// Fixes the overlapping problem of the component
										menu: provided => ({ ...provided, zIndex: 9999 }),
										menuPortal: provided => ({ ...provided, zIndex: 9999 })
									}}
									placeholder="Select a driver"
									className="react-select-container"
									classNamePrefix="react-select"
								/>
							</div>
						)}

						{companySettings && companySettings.isShowRutePlan === 'N' && (
							<div className="col-md-4 d-flex align-items-end">
								<button
									type="button"
									onClick={createManifestEvent}
									className="acceptbtn"
								>
									Create Manifest
								</button>
							</div>
						)}

						{companySettings && companySettings.isShowRutePlan === 'Y' && (
							<div className="col-md-12 d-flex align-items-end">
								<button
									type="button"
									className="acceptbtn"
									onClick={() => {
										console.log('Plan Route clicked, checkedValues:', checkedValues);
										if (checkedValues.length > 0) {
											console.log('Opening route modal with checkedValues:', checkedValues);
											setShowRouteModal(true);
										} else {
											Swal.fire({
												title: 'Error',
												text: 'Atleast one order should be selected to plan route.',
												icon: 'error',
												showConfirmButton: false,
												timer: 2000,
												timerProgressBar: true,
											});
										}
									}}
								>
									Plan Route
								</button>
							</div>
						)}
					</div>
					<div className="dashboard resizableCreateNewManifest">
						<div className="col-md-12 col-lg-12 col-xs-12">
							<div className="verical-scrl-wrapper create-manifest-table" id="style-3">
								<table
									className="table table-bordered dataTable resizable"
									ref={tableRef}
									id="resizableCreateNewManifestTable"
								>
									<thead>
										<tr>
											<th style={{ width: colWidths[0], minWidth: 50, position: "relative" }}>
												<label className="checkbox">
													<input
														type="checkbox"
														id="selectAllManifest"
													/>
													<span className="default"></span>
												</label>
												<div
													className="th-resizer"
													onMouseDown={(e) => startResizing(0, e)}
												/>
											</th>
											{[
												"Inv Date",
												"Inv No",
												"Customer Name(A/C No)",
												"Post Code",
												"Invoice Amt",
												"Total Due",
												"Sales Rep Cash",
												"Route",
												"Added By",
											].map((header, idx) => (
												<th
													key={header}
													style={{ 
														width: colWidths[idx + 1], 
														minWidth: 50, 
														position: "relative",
														textAlign: header === "Inv No" ? "left" : "right"
													}}
												>
													{header}
													{idx < colWidths.length - 2 && (
														<div
															className="th-resizer"
															onMouseDown={(e) => startResizing(idx + 1, e)}
														/>
													)}
												</th>
											))}
										</tr>
									</thead>
									<tbody></tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			<FlashMessage
				message={flashMessage?.message}
				type={flashMessage?.type}
				onClose={handleCloseMessage}
			/>
			{showRouteModal && (
				<div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
					<div className="modal-dialog modal-xl" style={{ maxWidth: '90%' }}>
						<div className="modal-content rounded-0">
							<div className="modal-body p-0" style={{ height: '90vh', position: 'relative' }}>
								{/* Windows-style close button */}
								<button 
									type="button" 
									className="btn-close-windows" 
									onClick={() => {
										setShowRouteIframe(false);
										setIsIframeLoading(false);
										setShowRouteModal(false);
									}}
									style={{
										position: 'absolute',
										top: '0px',
										right: '0px',
										zIndex: 1000,
										width: '30px',
										height: '30px',
										border: 'none',
										background: '#f44336',
										// borderRadius: '50%',
										color: 'white',
									}}
									onMouseEnter={(e) => {
										e.target.style.background = '#d32f2f';
										e.target.style.transform = 'scale(1.1)';
									}}
									onMouseLeave={(e) => {
										e.target.style.background = '#f44336';
										e.target.style.transform = 'scale(1)';
									}}
								>
									×
								</button>
								
								{/* Loading indicator */}
								{isIframeLoading && (
									<div style={{
										position: 'absolute',
										top: '50%',
										left: '50%',
										transform: 'translate(-50%, -50%)',
										zIndex: 999,
										background: 'rgba(255, 255, 255, 0.9)',
										padding: '20px',
										borderRadius: '10px',
										boxShadow: '0 0 10px rgba(0,0,0,0.3)'
									}}>
										<div className="d-flex flex-column align-items-center">
											<div className="spinner-border text-primary" role="status">
												<span className="visually-hidden">Loading...</span>
											</div>
											<div className="mt-2">Loading route planner...</div>
										</div>
									</div>
								)}
								
								{showRouteIframe && (
									<iframe
										key={`route-iframe-${iframeKey}`}
										src={`/maproute.html?postcodes=${checkedValues && checkedValues.length > 0 ? checkedValues.join(',') : ''}`}
										width="100%"
										height="100%"
										style={{ border: 'none' }}
										title="Route Planner"
										onLoad={() => {
											console.log('Route iframe loaded successfully with checkedValues:', checkedValues);
											setIsIframeLoading(false);
										}}
										onError={(e) => {
											console.error('Route iframe failed to load:', e);
											setIsIframeLoading(false);
										}}
									></iframe>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
			<Footer />
		</>
	);
};

export default CreateNewManifest;
